module.exports = __webpack_public_path__ + "img/2.1aba2cea.png";